/*
 * HC product media frame - the tap half of the hero/detail swap.
 *
 * Desktop does the whole job in CSS: hovering the frame crossfades the detail
 * in, on the same --hc-t-card-swap timing the product cards use. A touch screen
 * has no hover, so this element turns a tap anywhere on the frame into the same
 * state change, and keeps the pill in the corner in sync as the accessible
 * control for it.
 *
 * The frame renders inside the wrapper assets/hc-product-variant.js swaps on a
 * variant change, so a variant switch replaces this element outright and
 * connectedCallback binds the new one. Nothing here reaches outside the element
 * and there is no teardown to do: the listeners die with the node.
 *
 * A frame with no detail - the Digital chart variant, a chart-only product, a
 * product still holding a single image - renders no pill and no second <img>,
 * and is left completely inert.
 */
if (!customElements.get('hc-media-frame')) {
  customElements.define(
    'hc-media-frame',
    class HcMediaFrame extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.hc-media-frame__stage');
        this.toggleButton = this.querySelector('[data-hc-media-toggle]');
        if (!this.stage || !this.toggleButton) return;

        this.toggleLabel = this.querySelector('[data-hc-media-toggle-label]');

        this.toggleButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.setDetail(!this.classList.contains('is-detail'));
        });

        /* A tap on the image itself does the same thing. Pointer events keep
           this to coarse pointers and stylus taps; a mouse already has hover,
           and a click there would fight it. */
        this.stage.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse') return;
          this.setDetail(!this.classList.contains('is-detail'));
        });
      }

      setDetail(on) {
        this.classList.toggle('is-detail', on);
        this.toggleButton.setAttribute('aria-pressed', on ? 'true' : 'false');

        const ariaLabel = on ? this.toggleButton.dataset.ariaDetail : this.toggleButton.dataset.ariaHero;
        if (ariaLabel) this.toggleButton.setAttribute('aria-label', ariaLabel);

        const label = on ? this.toggleButton.dataset.labelDetail : this.toggleButton.dataset.labelHero;
        if (label && this.toggleLabel) this.toggleLabel.textContent = label;
      }
    }
  );
}
